import MarketingContentPage from "@/components/marketing/MarketingContentPage"

export default function Press() {
  return <MarketingContentPage pageKey="press" seoKey="press" />
}
